module.exports = __webpack_public_path__ + "static/img/product_tagHelmet.a3f2b1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_tagHelmet.jpg
// module id = j/RG
// module chunks = 0